import { createApp } from "vue";
import App from "./App.vue";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    default: "mdi", // Set mdiSvg as the default icon font
  },
});

//only for local
  //  createApp(App).use(vuetify).mount("#app");

//only for plugin
document.addEventListener("DOMContentLoaded", () => {
  const loadElements = [];
  // Function to load Vue.js applications when they come into view
  function loadApp() {
    // Find all elements with class "pnel-container"
    const appContainers = document.querySelectorAll(".pnel-container");
    // Iterate through each container
    appContainers.forEach((container) => {
      if (!loadElements.includes(container.id)) {
        // Get the height of the window and the container's position relative to the viewport
        let height = window.innerHeight;
        let topheight = container.getBoundingClientRect().top;
        // Check if the container is at least 10% visible in the viewport
        if (height - (height * 10) / 100 >= topheight) {
          // Add the container's ID to the loaded elements array
          loadElements.push(container.id);
          // Create and mount a Vue.js app in the container
          createApp(App).use(vuetify).mount(`#${container.id}`);
          // Remove event listener after mount app
          if (appContainers.length == loadElements.length) {
            document.removeEventListener("scroll", loadApp);
          }
        }
      }
    });
  }
  // Event listener to trigger the loadApp function on scroll
  document.addEventListener("scroll", loadApp);
  // Initial call to loadApp to handle elements that are already in view
  loadApp();
});
